export default {
  home: {
    loading: 'Loading',
  },
  sideBar: {
    // menu
    deployment: 'GTM Deployment',
    builder: 'Event Builder',
    connect: 'GTM Connector',
    server: 'Server-side Setup',
    platform: 'Platform Integration',
    audit: 'Audit',
    setup: 'Verify & Launch',
    dashboard: 'Dashboard',
    dashboardCategory: {
      sectionTitle: 'Dashboard',
      overview: 'Overview',
    },
    // config
    management: 'Site Management',
    documentation: 'Documentation',
    pricing: 'Pricing Plan',
    setting: 'Settings',
    UserManagement: 'User Management',
    billing: 'Billing & Subscription',
    subscription: 'Subscription',
    // shopify
    shopify: {
      sectionTitle: 'DEPLOYMENT',
      events: 'Choose Events to Track',
      connect: 'Connect Google Tag Manager',
      server: 'Enable Server-side Tracking',
      platform: 'Connect Platforms',
      setup: 'Verify & Launch',
      deploy: 'Review & Deploy to GTM',
    },
  },
  siteSelect: {
    createBtn: 'New site',
    placeholder: 'Select site',
    delete: {
      title: 'Delete site',
      desc: 'Confirmed to delete the site?',
      success: 'Site deleted',
    },
    subscribe: {
      title: 'Cannot delete subscribed site',
      desc: 'This site is currently linked to an active subscription.  Please cancel the subscription first before deleting the sGTM site.',
      success: 'Manage Subscription',
    },
    rename: {
      tip: 'Site name cannot be empty',
    },
    add: {
      switchSite: 'Site created. Redirecting...',
    },
    quotaLimit: 'You have reached the maximum number of sites allowed.',
  },
  deployment: {
    title: 'Deployment',
    checkList: {
      confirmation: {
        title: 'Deployment Confirmation ',
        events: 'Tracked Events',
        connect: 'GTM Connection',
        server: 'Server-side Setup',
        platform: 'Connected Platforms',
      },
      status: {
        title: 'Deployment Status',
        detail: 'Task Details',
      },
    },
    plan: {
      title: 'Tracked Events',
      empty: {
        desc: 'No plan available. Please create a tracking plan to proceed.',
        btnLabel: 'Create Tracking Plan',
      },
    },
    server: {
      title: 'Server-side Setup',
      using: 'Using {type}',
      selection: 'Server Selection',
      customName: 'Custom Domain Name',
      customUrl: 'Custom URL',
      notSelect: 'Server-side tracking not required',
      empty: {
        desc: 'No container configured. Connect to GTM and select containers to continue.',
        btnLabel: 'Go to Server Setup',
      },
    },
    platform: {
      title: 'Connected Platforms',
      webEvent: 'Web Events',
      serverEvent: 'Server Events',
      remark: 'Re-marketing Events',
      conversion: 'Conversion Events',
      noToken:
        'You need to provide the API Access Token under the Facebook platform to enable CAPI. Please go to {link} to configure it.',
      tiktok: {
        noToken:
          'You need to provide the API Access Token under the TikTok platform to enable CAPI. Please go to {link} to configure it.',
      },
      klaviyo: {
        events: 'Conversion Events',
      },
      empty: {
        desc: 'No active platforms. Please go to Platform Integration to set up your platforms.',
        btnLabel: 'Add Platform',
      },
      leakGa4: 'GA4 connection is required to deploy tracking. Go Connect GA4',
      leakGa4Key: 'Go Connect GA4',
    },
    auth: {
      title: 'GTM Connection ',
      label: 'GTM Connection',
      setup: 'Setup GTM',
      reauth: 'Switch GTM Account',
      leakServer:
        'No server container GTM ID found under the authorized account. Please re-authorize or update your server GTM configuration.',
      needSetup: 'GTM inactive. Reconfigure before deploy.',
      fixNow: 'Fix Now',
      valueEmpty: 'cannot be empty. Fix Now',
      valueEmptyWithField: '{fieldName} cannot be empty',
      connect: {
        web: {
          title: 'Web',
          account: 'Account',
          container: 'Web Container',
          workspace: 'Web Workspace',
        },
        server: {
          title: 'Server',
          account: 'Account',
          container: 'Server Container',
          workspace: 'Server Workspace',
          containerEmpty:
            'There is no server container under this account. Please reselect or refresh after creating one.',
        },
      },
      empty: {
        desc: 'No custom domain configured. Please add one.',
        btnLabel: 'Connect to GTM ',
      },
    },
    deploy: {
      title: 'Confirm Deployment',
      desc: 'You are about to deploy the following configuration to GTM. Please review all items before proceeding.',
      config: 'Platform & Events',
      container: 'Target GTM Containers',
      web: 'Web Container',
      server: 'Server Container',
      empty: '{type} is required',
      confirm: 'Confirm & Deploy',
      redeploy: 'Redeploy',
      emptyCardDesc: 'No deployment tasks yet. Click Deploy to start your deployment.',
      deploySuccess: 'Deploy successful. Go to the Web and Server containers in GTM and click Submit.',
      deploySuccessWeb: 'Web',
      deploySuccessServer: 'Server',
    },
    detail: {
      title: 'Deploy Job {status}',
      web: 'Web',
      server: 'Server',
      link: 'Go to GTM to review the {web} and {server} containers, then click Submit to publish your changes.',
      loading: 'Deploy Job Initializing',
      dashboardHint: 'After submitting in GTM, visit the Dashboard to monitor your incoming event data in real time.',
      dashboardLink: 'Go to Dashboard →',
    },
    report: {
      title: 'GTM Preview Report',
    },
  },
  dashboard: {
    title: 'Data Reception',
    pageTitle: 'Overview',
    showingEvents: 'Showing {start}-{end} of {total} events',
    table: {
      status: 'Status',
      eventName: 'Event Name',
      totalReceived: 'Total Received',
      latestReceived: 'Latest Received',
    },
    filter: {
      timezone: 'Timezone',
      dateRange: {
        today: 'Today',
        yesterday: 'Yesterday',
        last7: 'Last 7 days',
        last30: 'Last 30 days',
      },
      eventsPlaceholder: 'Select events',
    },
    empty: {
      noSite: 'Please select a site first.',
      desc: 'No data received. Please check: 1) GTM changes are submitted; 2) Your date range.',
      serverNotConfigured: {
        title: 'Server Not Configured',
        desc: 'Enable server-side tracking to start collecting data with improved accuracy.',
        btn: 'Set Up Server',
      },
      filteredEmpty: {
        title: 'No Events Received Yet',
        desc: "We haven't received any tracking events in this period.",
        reason1: "Your GTM container hasn't been submitted yet",
        reason1Link: 'Learn how to preview and submit GTM container',
        reason2: 'No data matches the current time range or event filter',
        reason2Hint: 'Try adjusting the filters above',
      },
    },
    error: {
      timeout: 'Request timed out. Please try again.',
      '403': 'Authorization required. Please re-authorize.',
    },
    topology: {
      title: 'Data Flow Topology',
      tip: 'Shows how data flows from your web source, through JTracking Server, to connected platforms.',
      webSource: 'Web Source',
      jtrackingServer: 'Tracking Server',
      addPlatform: 'Add Platform',
      setUp: 'Set up',
      status: {
        active: 'Active',
        healthy: 'Healthy',
        idle: 'Idle',
        error: 'Error',
        not_configured: 'Not Deployed',
        connected: 'Connected',
        disconnected: 'Disconnected',
      },
      drawer: {
        websiteSourceTitle: 'Website Source',
        jtrackingServerTitle: 'JTracking Server',
        activeReceivingEvents: 'Active - Receiving Events',
        siteUrl: 'Site URL',
        webContainerId: 'Web Container ID',
        editGtmConnector: 'Edit GTM Connector',
        containerId: 'Container ID',
        location: 'Location',
        defaultDomain: 'Default Domain',
        customDomain: 'Custom Domain',
        notConfigured: 'Not deployed',
        addFirstPartyDomain: '+ Add First-party Domain',
        ga4Title: 'Google Analytics 4',
        gadsTitle: 'Google Ads',
        metaTitle: 'Meta',
        tiktokTitle: 'TikTok',
        klaviyoTitle: 'Klaviyo',
        connection: 'Connection',
        ga4Account: 'Google Analytics Account',
        ga4Property: 'GA4 Property',
        ga4MeasurementId: 'GA4 Measurement ID',
        conversionId: 'Conversion ID',
        conversionEvents: 'Conversion Events',
        xEventsConfigured: '{count} events configured',
        metaPixelId: 'Meta Pixel ID',
        metaCapiAccessToken: 'Meta CAPI Access Token',
        testEventCode: 'Test Event Code',
        tiktokPixelId: 'TikTok Pixel ID',
        tiktokAccessToken: 'API Access Token',
        klaviyoApiKey: 'Private API Key',
        notSet: 'Not set',
        edit: 'Edit',
        goConnect: 'Go Connect',
      },
    },
  },
  builder: {
    title: 'Event Builder',
    report: 'How This Tracking Plan Drives Business Growth',
    firstTip: `What’s next?  
Are you looking to refine the plan further? Here are some related questions, or feel free to ask your own:  
1. Tell me how you’d like to optimize your tracking plan.  
2. Click **Apply** if the plan meets your business needs – we’ll create the GTM config in the sandbox and run automated tests.`,
    steps: {
      one: 'Create Site Map',
      two: 'Design Measurement Plan',
      three: 'Generate GTM Config',
    },
    chat: {
      title: 'Tracking Plan Agent',
      loading: 'Wait until the task is completed to continue chatting...',
      contentLoading: 'Chat loading, please wait...',
      history: 'History',
      placeHolder: 'Ask me everything about table',
      tip: 'JTracking is waiting for you to continue',
      oldSession: {
        title: 'Confirm Site Update',
        desc: `Due to the latest JTracking upgrade, some data from your existing sites is no longer compatible.  
Please re-submit your tracking intentions to generate a new tracking plan.`,
      },
      errorContent: {
        resolved: `The website address couldn’t be resolved.  

Please check the URL and make sure the domain is correct, then try again.`,
        timeout: `The website took too long to respond.  

This may be a temporary issue. Please try again later.`,
        unreachable: `The website couldn’t be reached from the internet.  

Please make sure the site is publicly accessible and try again.`,
        invalid: `No trackable elements were detected on this page.  
Try entering a different URL, or update the page and try again.`,
        blocked: `The website may have blocked automated access.  

Please add our crawler to your whitelist and try again.`,
        sslMismatch: `**The connection to this website is not secure.**

This may be due to an outdated browser or cached security settings. Please try clearing your browser cache or updating Google Chrome to the latest version and try again.`,
        fallback: `**Something went wrong.**

An unexpected error occurred while loading the page. Please check your internet connection or try again in a few moments.`,
      },
      errorBtn: {
        newUrl: 'Enter a new URL',
        whitelist: 'How to whitelist the jtracking crawler',
      },
    },
    // 意图
    intent: {
      label: 'Tracking Intentions',
      title: `Select how you want to generate your tracking plan`,
      desc: 'Choose a generation mode. You can start from a standard template or let AI analyze your site and tailor the plan to your goals.',
      attention: "I'm generating your tracking plan and will begin delivering results in about one minute.",
      custom: 'Custom',
      full: 'Full Generation',
      template: 'Standard eCommerce template (30s)',
      ai: 'Custom plan with AI (2min)',
      tip: `*These selections will ensure precise event design.*`,
      generate: 'Generate',
      disabled_tip: 'Please select at least one option',
      select_tip: 'Please select at least 1 default option',
      limit_tip: 'Maximum 500 characters allowed',
      full_generate: 'Generate a tracking plan for the entire site',
      addition: {
        title: '_Additional Requirements (Optional)_',
        desc: `You could say: 'Need to track billing cycle selection in subscription plans'`,
        placeholder: 'Please enter your requirements',
      },
      extra: {
        title: 'Additional Custom Events',
        add_btn: 'Add Event',
        tip: {
          no_validate: 'Special characters are not allowed',
          empty: 'Can not be empty',
          limit: 'Exceeds 50 characters limit',
        },
      },
      confirm: {
        title: `All set with these tracking targets?`,
        desc: `I’ll use your current selections to generate the tracking plan.  
  
  - Don’t worry — the targets won’t update automatically, but you can always tell me what you need, and I’ll help adjust it for you.`,
        back_btn: 'Back to Editing',
        go_btn: 'Generate Now',
      },
    },
    // 建议
    suggestion: {
      success: 'Generate success',
      title: 'You can also ask: ',
    },
    // welcome
    welcome: {
      desc: `For **{url}**, JTracking will generate the following deliverables:`,
      detail: `
1. **Ad Tracking Plan** – Automatically created based on your site structure, aligned with advertising tracking best practices.  
2. **GTM Configuration** – Deployment-ready GA4 tags, triggers, and variables for accurate event collection.  

Begin by scanning your site and generating your tracking plan. We only scan 10–20 pages and do not change your site or existing data. This is fully safe.`,
      welcomeBtn: 'Scan My Website',
    },
    // spider
    spider: {
      start: 'Please generate a tracking plan for {site}',
      page: 'Sitemap generated, here are all page groups and some examples',
      reScrape: 'Please re-scrape the site information',
      error:
        'The scraping task has failed. Please verify the site configuration and ensure there are no connectivity issues. Try again later or contact support for assistance. ',
    },
    // 进程和子任务相关
    progress: {
      spider: {
        start: 'Scraping in progress...',
        end: 'Scraping completed',
        failed: 'Scraping failed',
      },
      siteMap: {
        start: 'Generating sitemap...',
        end: 'Sitemap generated',
        tip: 'The sitemap has been generated for you on the left.',
        empty: 'Sitemap Empty',
      },
      running: 'Elapsed {time}',
      finish: 'Duration {time}',
      failed: 'Failed',
      scraped: '{num} pages scraped, current: {url}',
      error: 'Task Failed',
    },
    plan: {
      title: 'Tracking Plan',
      apply: 'Apply Plan',
      cta: 'CTA: A prompt (button or link) that encourages users to take a specific action, like signing up or buying.',
      conversion:
        'Conversion: The successful completion of the desired action, such as a user registering or making a purchase.',
      ecommerce: 'E-commerce',
    },
    siteMap: {
      title: 'Sitemap',
      desc: 'Sitemap generated, here are all groups and some example pages',
    },
    apply: {
      title: 'Apply',
      warningTip:
        'The applied plan does not include {list}. These events will be invalid in Google Ads Conversion Events.',
      form: { gtm: 'GTM id', gtmPlaceholder: 'Please enter your GTM id' },
      progress: {
        loading: 'Applying tracking plan...',
        success: 'Tracking Plan Applied',
        failed: 'Application Failed',
      },
      step: {
        shopify: 'Shopify Setup',
        apply: 'Apply',
      },
      confirm: {
        title: 'Apply Confirmation',
        desc: `A GTM configuration for GA4 events will be generated in the sandbox and validated through automated tests.  
This will not affect your live GTM or production data.`,
        after:
          'After successfully applying the tracking plan, it will be available later in the Deployment to push to your GTM container.',
        confirm: 'Apply in Sandbox ',
      },
    },
    shopify: {
      coreEvents: 'Primary E-commerce Conversion Events',
      advanceEvents: 'Supplementary E-commerce Conversion Events',
      tip: {
        applySuccess: 'Events confirmed successfully',
        tag: 'Platform connected for this event',
      },
    },
    emptyTip: 'No Tracking Plan yet. Create one on the right to get started.',
  },
  createSite: {
    tip: {
      empty: 'Empty URL',
      invalid: 'Invalid URL (https://www.example.com)',
      placeHolder: 'Please enter your website (https://www.example.com)',
    },
    message: {
      exist: 'This site already exists, redirecting...',
    },
  },
  platform: {
    title: 'Platform Integration',
    saveSuccess: 'Platform saved and enabled successfully',
    saveSuccessWithoutEnable: 'Platform saved',
    requied: 'Required field cannot be empty',
    switchTip: 'Complete setup before enabling',
    disabled: 'Complete setup before enabling',
    notServer: 'Complete {platform} and server-side tracking setup before enabling',
    ga4Required: 'GA4 is required. Please complete and enable GA4 configuration.',
    unsavedChanges: {
      title: 'Unsaved Changes',
      desc: 'You have unsaved changes in **{channels}**. Continuing will discard these changes.',
      confirm: 'Proceed',
    },
    ga: {
      title: 'Google Ads',
      conversionId: 'Conversion ID',
      conversionEvent: 'Conversion Events',
      no: 'No.',
      eventName: 'Event',
      conversionLabel: 'Conversion Label',
      total: 'A total of {num} items',
      searchTotal: 'A total of {num} items were found',
      conversionTip: 'Conversion Label is required for the selected Event Name.',
      invalid: 'Invalid Conversion Events detected. Review details to update.',
      leakEvent: 'This event is not applied yet and won’t be included in Deployment',
      tip: {
        conversion: {
          desc: 'Identifies your Google Ads account for conversion tracking.',
          link: 'Where to find',
        },
        events: {
          desc: 'Represents a specific user action to measure in Google Ads.',
          link: 'Learn more',
        },
        label: {
          desc: 'Differentiates specific conversion actions under the same Conversion ID.',
          link: 'Where to find',
        },
      },
      switchAccount: 'Switch Google Ads Account',
      selectConversionIdFirst: 'Please select Conversion ID first',
      mismatchWarning:
        'Data mismatch detected after account switch. Please re-configure. This channel has been disabled.',
      emptyGa: 'No Google Ads configured. Connect Google Ads to continue.',
      emptyBtn: 'Connect to Google Ads',
    },
    ga4: {
      title: 'Google Analytics 4',
      measureId: 'GA4 Measurement ID',
      placeHolder: 'G-1234567890',
      errorMsg: 'Please enter a valid Measurement ID in the format G-XXXXXXXXXX.',
      accountName: 'Google Analytics Account',
      propertyName: 'GA4 Property',
      link: 'Go Connect GA4',
      emptyGa: 'No GA4 configured. Connect GA4 and select a Measurement ID to continue.',
      emptyBtn: 'Connect to GA4',
      switchAccount: 'Switch GA4 Account',
      googleTagId: 'Google Tag Id',
      mismatchWarning:
        'Data mismatch detected after account switch. Please re-configure. This channel has been disabled.',
      leakGATip: 'Connect GA4 and select a Measurement ID to enable.',
    },
    fb: {
      title: 'Facebook',
      pixelId: 'Meta Pixel ID',
      token: 'Meta CAPI Access Token',
      textId: 'Test Event Code',
      textIdTip:
        'This field is only effective in GTM Preview Mode. Events will be sent to Facebook as test data. In non-Preview Mode, this field has no effect.',
      webTitle: 'Client Events',
      serverTitle: 'Server Events',
      tip: {
        pixel: {
          desc: 'Identifies the pixel used to collect events for Meta measurement and optimization.',
          link: 'Where to find',
        },
        token: {
          desc: 'Allows your server-side setup to send events to Meta via the Conversions API.',
          link: 'Where to find',
        },
        test: {
          desc: 'Used to test client-side and server-side events in Meta Events Manager without affecting real data.',
          link: 'Where to find',
        },
      },
    },
    tiktok: {
      title: 'TikTok',
      pixelId: 'TikTok Pixel ID',
      token: 'API Access Token',
      textId: 'Test Event Code',
      textIdTip:
        'This field is only effective in GTM Preview Mode. Events will be sent to TikTok as test data. In non-Preview Mode, this field has no effect.',
      tip: {
        pixel: {
          desc: 'Identifies the pixel used to collect events for TikTok measurement and optimization.',
          link: 'Where to find',
        },
        token: {
          desc: 'Allows your server-side setup to send events to TikTok via the Events API.',
          link: 'Where to find',
        },
        test: {
          desc: 'Used to test client-side and server-side events in TikTok Events Manager without affecting real data.',
          link: 'Where to find',
        },
      },
    },
    klaviyo: {
      title: 'Klaviyo',
      apiKey: 'Private API Key',
      events: 'Conversion Events',
      invalid: 'Invalid Conversion Events detected. Review details to update.',
      tip: {
        apiKey: {
          desc: 'Your Klaviyo Private API Key used to send server-side conversion events.',
          link: 'Where to find',
        },
        events: {
          desc: 'Select the GA4 events you want to track as conversions in Klaviyo.',
          link: 'Learn more',
        },
      },
    },
  },
  local: {
    en: 'English',
  },
  planTable: {
    loading: 'Plan loading, please wait...',
    empty: 'Empty Plan',
    event: {
      desc: 'Description',
      group: 'Page group',
    },
    error: {
      eventRepeat: 'Event name already exists',
      propRepeat: 'Parameter name already exists under this event',
      limit: 'Maximum length is {num} characters',
      notEmpty: '{type} name is required',
      startWithLetter: 'Must start with a letter',
      onlyMark: 'Only letters, numbers and underscores are allowed',
      propLimit: 'Property name maximum length is {num} characters',
    },
    delete: {
      event: 'Delete {event}?',
      eventDesc: 'Are you sure? This will also remove all associated parameters and can not be undone.',
      prop: 'Delete {prop}',
      propDesc: 'Delete selected parameters? This cannot be undone.',
    },
  },
  user: {
    logout: 'Logout',
    spAdmin: 'Super Admin',
  },
  login: {
    title: 'JTracking delivers end-to-end ad tracking, from setup to data delivery.',
    desc: 'Sign in to complete your ad conversion tracking',
    googleBtn: 'Sign in with Google',
    divider: 'or',
    signInBtn: 'Sign in',
    signingIn: 'Signing in...',
    credentialsError: 'Incorrect email or password. Please check and try again.',
    credentialsErrorWithAttempts:
      'Incorrect email or password. Please check and try again. ({remaining} attempts remaining)',
    accountLockedError:
      'Too many failed login attempts. Your account has been temporarily locked. Please try again in 30 minutes.',
    accountLockedWithTime: 'Your account is locked. Please try again after {time}.',
    accountDisabledError: 'Your account has been disabled. Please contact support@jtracking.ai',
    accountNotVerifiedError: 'Your account is not yet verified.',
    googleOnlyAccountError: 'This email is registered with Google only. Sign in with Google or Set a password?',
    accountNotVerifiedMessage: 'Your account is not yet verified, Please verify your email first, {resendLink}',
    resendVerificationEmail: 'Resend verification email',
    setPasswordLink: 'Set a password',
    or: 'or',
    signupLink: {
      text: "Don't have an account?",
      linkText: 'Sign up',
    },
    forgotPassword: 'Forgot password?',
    email: {
      label: 'Email',
      placeholder: 'name@work-email.com',
      emptyError: 'Please enter your email address.',
      invalidError: 'Please enter a valid email address (e.g. name@company.com).',
    },
    password: {
      label: 'Password',
      placeholder: 'Enter your password',
      emptyError: 'Please enter your password.',
    },
    signup: {
      desc: 'Start your ad conversion tracking journey.',
      googleBtn: 'Sign up with Google',
      email: {
        placeholder: 'name@work-email.com',
      },
      displayName: {
        label: 'Display Name',
        placeholder: 'Enter your display name',
        hint: '2-50 characters. Letters, numbers, spaces, _ and -.',
        emptyError: 'Please enter a display name.',
        lengthError: 'Display name must be 2-50 characters.',
        invalidCharactersError: 'Only letters, numbers, spaces, _ and - allowed.',
        startWithError: 'Display name cannot start with a space or hyphen.',
        endWithError: 'Display name cannot end with a space or hyphen.',
      },
      password: {
        placeholder: 'Create a password',
        hint: '8-128 characters. Letters, numbers, and symbols allowed.',
        lengthError: 'Password must be 8-128 characters.',
        invalidCharactersError: 'Password contains invalid characters.',
        strength: {
          weak: 'Weak',
          medium: 'Medium',
          strong: 'Strong',
        },
      },
      terms: {
        label: 'I agree to the {terms} and {privacy}',
        link: 'Terms of Service',
        privacyLink: 'Privacy Policy',
        error: 'You must agree to the Terms and Privacy Policy to create an account.',
      },
      createBtn: 'Create account',
      creating: 'Creating account...',
      successMessage: 'Account activated. Welcome!',
      error: 'Something went wrong. Please try again later.',
      emailAlreadyRegisteredMessage: 'This email is already registered. {loginLink} instead?',
      loginLink: {
        text: 'Already have an account?',
        linkText: 'Log in',
      },
    },
    forgot: {
      desc: "No worries, we'll send you reset instructions.",
      email: {
        placeholder: 'Enter your email address',
      },
      sendBtn: 'Send reset link',
      sending: 'Sending...',
      backToLogin: 'Back to log in',
      successMessage: `We've sent a password reset link to **{email}**. Please check your inbox.`,
      error: 'Failed to send reset email. Please try again later or contact support.',
    },
    verify: {
      title: 'Check your email',
      instruction: "We've sent a 6-digit verification code to\n{email}",
      code: {
        emptyError: 'Please enter the verification code.',
      },
      verifyBtn: 'Verify',
      verifying: 'Verifying...',
      error: 'Something went wrong. Please try again later.',
      resend: {
        text: "Didn't receive the code?",
        link: 'Resend',
        countdown: 'Resend code in {seconds}s',
        success: 'Code sent! Please check your inbox.',
        error: 'Failed to resend code. Please try again later.',
      },
      changeEmail: {
        text: 'Wrong email?',
        link: 'Change email',
      },
    },
    reset: {
      title: 'Reset your password',
      subtitle: 'Enter a new password for your account.',
      password: {
        label: 'New password',
        placeholder: 'Enter new password',
        hint: '8-128 characters. Letters, numbers, and special characters',
        emptyError: 'Please enter a new password.',
        formatError: 'Password must be 8-128 characters. Letters, numbers, and special characters',
      },
      resetBtn: 'Reset password',
      resetting: 'Resetting...',
      verifying: 'Verifying reset link...',
      successMessage: 'Password reset successfully! Redirecting to login...',
      error: 'Something went wrong. Please try again later.',
      errorExpired: 'This reset link has expired.',
      errorUsed: 'This reset link has already been used.',
      errorInvalid: 'Invalid reset link.',
      requestNewLink: 'Request a new one.',
    },
  },
  select: {
    empty: 'No results found',
    selectAll: 'Select All',
    invert: 'Invert',
  },
  server: {
    title: 'Server-Side Setup',
    create: {
      title: 'Use JTracking Server',
      desc: `**Fast, Reliable, and More Affordable than Other Hosting Providers.**  

1. **One-Click Deployment**  
Instantly create a fully managed Server-side GTM environment.  

2. **No Maintenance Required**  
Powered by JTracking’s servers—no need to rent or configure your own infrastructure.   

3. **Easy & Cost-Effective**  
More affordable than cloud services (AWS, GCP, Azure) and cheaper than other hosting providers.`,
      btn: 'Create sGTM Server',
    },
    limit: {
      title: 'Monthly Event Quota Reached',
      desc: '[{sites}] has reached its monthly event quota. Events beyond the buffer will not be collected. Upgrade your plan to continue full tracking.',
      moreDesc:
        '[{sites}] have reached their monthly event quotas. Events beyond the buffer will not be collected. Upgrade your plan to continue full tracking.',
    },
    select: {
      title: 'Server Selection',
      desc: 'Please select a server before proceeding to deploy.',
      own: 'JTracking Server',
      thirdParty: 'Custom Server',
      none: 'Do not use server-side tagging',
      disabledTip: 'Configure server first to enable this option.',
    },
    changeType: {
      success: 'Server selection updated successfully',
    },
    own: {
      title: 'Use JTracking Server',
      desc: `**Fast, Reliable, and More Affordable than Other Hosting Providers.**  

**1. One-Click Deployment**  
Instantly create a fully managed Server-side GTM environment.  

**2. No Maintenance Required**  
Powered by JTracking’s servers—no need to rent or configure your own infrastructure.   

**3. Easy & Cost-Effective**  
More affordable than cloud services (AWS, GCP, Azure) and cheaper than other hosting providers.
`,
      displayName: 'sGTM name',
      containerConfig: 'Container Config',
      createBtn: 'Create sGTM Server',
      validContainer: 'Invalid container configuration',
      createSuccess: 'sGTM Created',
      errorTip: 'Must match the Server Container ID in GTM Connection',
      errorTipReplace: 'GTM Connection',
    },
    thirdParty: {
      title: 'Use Custom Server',
      desc: `**Full Control with Your Own Infrastructure.**  

**1. Custom Endpoint**  
Configure your own server URL to handle tracking requests.  

**2. Flexible Deployment**  
Integrate with your company’s infrastructure and compliance needs.  

**3. But Higher Maintenance Cost**  
 Requires setup, hosting, monitoring, and ongoing maintenance by your team.
`,
      url: 'Server Container URL',
      createBtn: 'Create',
      createSuccess: 'Server container URL saved',
      validUrl: 'Invalid URL',
    },
    none: {
      title: 'Create sGTM ',
      desc: `**Server-side tracking(SST) for Smarter Ad Tracking**  
Move tracking to the server for reliable ad data.  

**1. Accurate Ad Tracking**  
Capture conversions, clicks, and key events reliably, bypassing ad blockers and client-side limitations.  

**2. First-Party Domain**  
Use your own domain to send tracking requests, avoiding issues caused by ITP and other browser tracking restrictions.  

**3. Easy & Cost-Effective**  
Powered by JTracking's servers—no need to rent or configure your own. One click to deploy and start SST immediately.
`,
      name: 'sGTM name',
      container: 'Container',
      createBtn: 'Create Now',
    },
    usage: {
      title: 'sGTM Usage',
      updateBtn: 'Update Plan',
      usage: 'Request Usage',
      used: 'Used',
      limit: '{num} requests received',
      renew: 'Renews in {day} days',
      renewToday: 'Renews today',
      renewTomorrow: 'Renews tomorrow',
      retryPayment: 'Please complete the retry payment by {time} hours',
      btn: {
        change: 'Change Plan',
        cancel: 'Cancel Plan',
        subscribe: 'Subscribe',
        retryPay: 'Retry Payment',
      },
      tip: 'The number of requests your server-side setup has received so far in the current subscription period.',
    },
    domain: {
      title: 'Domains',
      default: 'Default Domain Name',
      empty: 'No custom domain configured. Please add one.',
      customTitle: 'Custom Domain Name',
      type: 'TYPE',
      host: 'HOST',
      value: 'Value',
      tip: 'A first-party subdomain to send server-side tracking data, improving accuracy and bypassing some ad blockers. For example, if your domain is www.demo.com, you can set this to track.demo.com.',
      verify: {
        default: 'Unverified',
        loading: 'Verifying',
        finish: 'Verified',
        failed: 'Failed',
        verifyTip: 'Current custom domain is not verified. Click Verify to validate.',
        verifyingTip: 'Verification in progress. Please wait or click {btn} to check the latest status.',
        verifyFailed: 'verifyFailed',
        formVerifyFailed: 'Please input a valid subdomain',
        required: 'Shopify verification is required before deployment.',
        requiredKey: 'Go Verify',
      },
      delete: {
        title: 'Confirm Domain Deletion',
        desc: 'Are you sure you want to remove the custom domain？',
      },
      custom: {
        add: 'Add First-party Domain',
        title: 'Custom Domain',
        customDomainName: 'Domain name',
      },
    },
    info: {
      title: 'Basic Information',
      serverStatus: 'Server Status',
      containerId: 'Container ID',
      location: 'Location',
      url: 'Site URL',
      updateSuccess: 'Configuration updated successfully.',
      delete: {
        title: 'Confirm Deletion',
        desc: 'Are you sure you want to delete this container? This action cannot be undone. ',
      },
      form: {
        displayName: 'Server Container Name',
        displayNameEmpty: 'Can not be empty',
        containerConfig: 'Container configuration',
        placeholder: 'e.g. My Shopify sGTM',
        title: 'Confirm Edit',
        desc: 'Are you sure you want to update this configuration?',
      },
    },
  },
  // management
  management: {
    title: 'Site management',
    add: 'Add New Site',
  },
  // management
  userManagement: {
    placeholder: 'User Name',
    rolePlaceHolder: 'Select Role',
    modify: 'Modify Role',
    updateSuccess: 'Update Success',
    invite: 'Generate an Invitation Link',
    inviteTitle: 'The invitation link has been generated.',
    persona: 'Persona',
    table: {
      id: 'ID',
      anonymousId: 'AnonymousId',
      email: 'Email',
      name: 'Name',
      createTime: 'Create Time',
      roles: 'Roles',
      action: 'Action',
    },
  },
  // video
  video: {
    title: 'Need help getting started?',
    desc: `Watch the tutorial or check our [step-by-step guide](https://www.jtracking.ai/blog/jtracking-product-guide/) to get started.`,
    play: {
      title: 'Getting Started with JTracking',
    },
  },
  // welcome
  welcome: {
    skip: 'Skip for Now',
    title: 'Create New Site',
    desc: 'Enter your website to unlock full tracking automation, from AI-powered plans to server-side GTM setup.',
    url: 'Website URL',
    tip: 'Entering your website is safe. It will not affect your site, traffic, or existing data.',
    create: 'Create Site',
    step: {
      enter: {
        title: 'Enter your URL and build your site profile',
        desc: 'We’ll map your site and store all configurations associated with it.',
      },
      apply: {
        title: 'Apply your GTM configuration',
        desc: 'AI prepares all GTM tags, triggers, and variables — you simply select the setup you want to apply.',
      },
      server: {
        title: 'Choose your server-side setup',
        desc: 'Use JTracking’s managed server, your own server, or opt out of server-side tracking.',
      },
      platform: {
        title: 'Connect your platforms',
        desc: 'Configure the analytics and advertising platforms you want to integrate.',
      },
      auth: {
        title: 'Authorize GTM and complete deployment',
        desc: 'Select your GTM container; we’ll deploy all configurations to it and generate a GTM Preview Report.',
      },
    },
  },
  // subscription
  subscription: {
    title: 'Start Free, Upgrade as You Grow',
    desc: 'Reliable, AI-powered server-side tracking that cuts cost and boosts accuracy',
    includes: 'What’s included',
    back: 'Back to JTracking',
    payment: {
      title: 'Payment',
      method: 'Payment method',
      summary: 'Order summary',
      pay: 'Pay Now',
      secured: 'Payments secured by stripe.',
      allPrice: 'All prices in USD.',
      discount: 'Discount',
      upgrade: 'Upgrade Proration Charge',
      upgradeTip:
        'The next invoice will include a prorated adjustment of ${price} based on the difference between your previous and current plan.',
      desc: {
        payment: {
          title: 'Payment Statement',
          desc: `This payment covers your **next subscription cycle.**  
If you are currently in an active subscription period, the amount will be charged automatically **at your next billing date.**`,
        },
        plan: {
          title: 'Plan changes',
          desc: `**Upgrades** take effect immediately, and the price difference will be charged on a prorated basis.  
**Downgrades** will take effect **at the start of your next billing cycle.**`,
        },
        support: {
          title: 'Support Information',
          desc: `Need help? Contact Support.`,
        },
      },
    },
    selectPayment: {
      title: 'Select Payment Method',
      desc: 'Select a saved payment method',
      add: 'Add New Payment Method',
      skip: 'Skip & Start Trial',
      secure: 'Payments secured by stripe All prices in USD',
    },
    setPayment: {
      title: 'Add Payment Method',
      card: 'Card Number',
      expiry: 'Expiration Date',
      cvc: 'CVC',
      save: 'Save Payment Method & Subscribe',
    },
    createPayment: {
      title: 'Secure payment powered by Stripe',
      desc: `- JTracking partners with Stripe to ensure your payment information is safe and secure.  
- We do not store your credit card details; all data is encrypted and processed by Stripe.  
- Fast, convenient, and secure—complete your payment with confidence.`,
      footer: 'Powered by Stripe',
      payTitle: 'Add Payment Method',
      saveBtn: 'Save Payment Method',
      setDefaultLabel: 'Use as default payment',
      setDefaultTip: 'Set this card as your default payment method',
    },
    editPayment: {
      payTitle: 'Edit Payment Method',
      saveBtn: 'Save Payment Method ',
    },
    btn: {
      trialing: 'Start Free Trial',
      change: 'Select Plan',
    },
    info: {
      subscribeSuccess: 'Subscription activated successfully',
      addPlanSuccess: 'Payment method successfully added',
      updatePlanSuccess: 'Payment method successfully edited',
      cancelSuccess: 'Subscription cancelled successfully',
      shopifyRedirect: 'Redirecting to Shopify...',
      back: {
        title: 'Subscription failed to activate',
        desc: 'Your payment information will not be saved. Are you sure you want to leave this page?',
      },
    },
  },
  // billing
  billing: {
    title: 'Billing & Subscription',
    loading: 'Loading',
    card: {
      title: 'Card Information',
      btn: 'Add New Payment',
      setDefaultSuccess: 'Default payment method enabled',
      paymentTime: 'Active until {date}',
      paymentTimeTip: 'After this date, your plan will downgrade to {plan}',
      remove: {
        title: 'Confirm removal of payment method',
        desc: 'Are you sure you want to remove this payment method?',
        success: 'Payment method removed',
      },
    },
    history: {
      title: 'Billing History',
      empty: 'No orders yet. Once you make a purchase, your order details will appear here',
      download: 'Download Invoice',
      detail: {
        title: 'Order Details',
        order: {
          title: 'Order Info',
          email: 'Customer Email',
          time: 'Payment time',
          invoice: 'Invoice Date',
          subtotal: 'Subtotal',
          total: 'Total',
          id: 'Order ID',
          status: 'Status',
          cycle: 'Billing Cycle',
          discount: 'Discount',
        },
        subscription: {
          title: 'Subscription Info',
          name: 'Site Name',
          start: 'Start Date',
          next: 'Next Billing Date',
          planName: 'Plan Name',
          end: 'End Date',
          unit: 'Unit Price',
        },
      },
      form: {
        id: 'Order ID',
        createTime: 'Payment Time',
        name: 'Plan Name',
        site: 'Site Name',
        cycle: 'Billing Cycle',
        amount: 'Payment Amount',
        operation: 'Operation',
      },
    },
    subscribe: {
      title: 'Subscriptions',
      empty: 'No sites found. Created your first site to get started.',
      form: {
        name: 'Site Name',
        subscription: 'Subscription',
        usage: 'Usage',
        platform: 'Platforms',
        domain: 'Server Domains',
        date: 'Next Billing Date',
        amount: 'Next Billing Amount',
        operation: 'Operation',
      },
      cancel: {
        title: 'Confirm Subscription Cancellation',
        desc: 'You are about to cancel the subscription for {siteName}. After {limit}, the site will switch to the Free Plan.',
      },
    },
  },
  // scope error
  scopeError: {
    title: 'GTM scope authorization failed',
    gaTitle: 'GA scope authorization failed',
    gadsTitle: 'Google Ads scope authorization failed',
    webTitle: 'Authorization issue detected',
    desc: `You may have encountered the following issues. Please verify and try again:
  
1. You may not have selected all the scope permissions required by jtracking. Please select all of them and continue.`,
    error: `2. Network issues.`,
    back: 'Back',
  },
  // persona
  persona: {
    site: {
      label: 'Enter Your Website URL',
      desc: 'Enter your website URL and JTracking AI will automatically create a customized tracking plan for your site.',
      attendtion: `Security & Privacy — what we do (and don’t do)  
- We **only read** the pages you approve for sitemap (no modifications during scanning).  
- We request OAuth permissions only for GTM/GA/Meta authorizations where needed — permissions are shown before you confirm.  
- We do not copy or share PII; any customer identifiers used for conversion must be hashed/obfuscated.  
- You can revoke permissions or uninstall the integration at any time — all injected snippets are removable`,
    },
    step: {
      industry: {
        label: 'Industry',
        title: 'Which best describes your business?',
        desc: 'We use this to pick recommended industry best practice and default conversion goals.',
        1: 'For stores that sell physical products (e.g., Shopify, WooCommerce, headless e-commerce).',
        2: 'For SaaS products, subscription services, web apps.',
        3: 'For local services, bookings and lead-gen.',
        4: 'Not listed above.',
      },
      role: {
        label: 'Role',
        title: 'Who are you on this project?',
        desc: 'Helps us show the right level of guidance and shortcuts.',
      },
      goal: {
        label: 'Goal',
        title: 'Do you know how ad tracking works?',
        desc: 'Pick the option that best describes your familiarity, and we’ll show options tailored to your level.',
        otherPlaceHolder: 'Please specify (optional)',
      },
      site: {
        label: 'Create Site',
        title: 'Which site are we setting up?',
        desc: 'Recover up to 30% of conversions lost due to browser restrictions and ad blockers.',
      },
    },
  },
  // guide
  guideTool: {
    quick: {
      title: 'Activate Ad Conversion',
      btn: 'Quick Start',
      jumpTip: 'Finish setup in {route}',
      deployJumpTip: 'Go Deploy',
      welcome: {
        title: 'Welcome to your setup guide',
        desc: `Follow these steps to enable server-side ad conversion tracking.  
        
You can close the guide anytime and reopen it whenever you need.`,
        got: 'Got it',
      },
      list: {
        builder: {
          title: 'Confirm Events to Track',
          btn: 'Go to Event Builder',
          1: {
            title: 'Scan your website',
            content: 'Click Scan My Website to let us review your pages and understand your site structure.',
            highlight1: 'Scan My Website',
          },
          2: {
            title: 'Choose what to track',
            content: 'Select the actions you want to track on your website, then click Generate Tracking Plan.',
            highlight1: 'Generate Tracking Plan',
          },
          3: {
            title: 'Apply a tracking plan',
            content: 'Click Apply to activate the plan you choose',
            highlight1: 'Apply',
          },
          4: {
            title: 'Confirm selected events',
            content: 'Select the events you want to track, then click Confirm to confirm your selection.',
            highlight1: 'Confirm',
          },
        },
        connect: {
          title: 'Connect Your GTM Container',
          btn: 'Go to GTM Connector',
          1: {
            title: 'Authorize GTM',
            content: 'Click Connect to GTM to complete the authorization.',
            highlight1: 'Connect to GTM',
          },
          2: {
            title: 'Connect both Web and Server GTM containers',
            content: 'Save your GTM container as the deployment target.',
            highlight1: 'Save',
          },
          3: {
            title: 'Verify your Shopify configuration',
            content: 'Complete the Shopify setup and Verify everything is working correctly.',
            highlight1: 'Verify',
          },
        },
        server: {
          title: 'Add Server-side Configuration',
          btn: 'Go to Server-side Setup',
          1: {
            title: 'Activate JTracking Server',
            content: 'Fill in sGTM details, then click Create sGTM Server to activate the JTracking Server. ',
            highlight1: 'Create sGTM Server',
          },
        },
        platform: {
          title: 'Add Platform Integrations',
          btn: 'Go to Platform Integration',
          1: {
            title: 'Authorize GA4',
            content: `Click Connect to GA4 to complete the authorization.`,
            highlight1: 'Connect to GA4',
          },
          2: {
            title: 'Connect to your GA4 data stream',
            content: `Select your GA4 Measurement ID and click Save.  

Your GA4 connection will be enabled automatically. You can add other platforms as needed.`,
            highlight1: 'Save',
          },
        },
        setup: {
          title: 'Pre-deploy Setup (Optional)',
          btn: 'Go to Setup',
          1: {
            title: 'Complete pre-deploy setup (optional)',
            content: 'This step is optional. Go to Setup and click Verify to confirm everything is working.',
            highlight1: 'Verify',
          },
        },
        deployment: {
          title: 'Complete Deployment',
          btn: 'Go to Deploy',
          1: {
            title: 'Complete the deploy task',
            content: 'Confirm all your configurations and Deploy.',
            highlight1: 'Deploy',
          },
          2: {
            title: 'Submit changes in GTM & check your data',
            content: 'Go to GTM and click Submit to publish. Then visit your Dashboard to monitor incoming event data.',
            highlight1: 'Dashboard',
          },
        },
      },
    },
  },
  // connect
  connect: {
    title: 'GTM Connector',
    config: {
      title: 'Connect Your GTM',
      titleConnected: 'Your GTM Connection',
      btn: 'Connect to GTM',
      whatIsGtm:
        'Google Tag Manager (GTM) is a free tool by Google. It lets you deploy tracking scripts — like Meta Pixel, GA4, or TikTok Pixel — to your store without touching the code.',
      steps: {
        title: 'What happens next',
        step1Label: 'Sign in with Google',
        step1Desc: 'Authorize access to your Google Tag Manager account.',
        step2Label: 'Select your GTM account',
        step2Desc: 'JTracking will detect your available GTM accounts and containers automatically.',
        step3Label: 'Container setup (if needed)',
        step3Desc: 'If you don’t have a container yet, JTracking can create one for you automatically.',
        step4Label: 'Ready to deploy',
        step4Desc: 'Your GTM account is now connected and ready for tracking setup.',
      },
      trustText:
        'We request Google Tag Manager access solely to sync your tracking tags directly to your container. We only manage tags related to jtracking.ai and will never modify or view your existing configurations.',
      hero: {
        title: 'Connect Google Tag Manager to activate conversion tracking',
        subtitle: 'Authorize your GTM account to automatically set up conversion tracking with JTracking.',
        perm1: 'Securely access your GTM accounts and containers',
        perm2: 'Automatically deploy tracking tags to your workspace',
        permNever: 'Never modify your existing tags or triggers.',
        btnHint: 'Takes ~30s · Revoke anytime in your Google account',
      },
      setupHelp: {
        title: "Don't have a GTM setup yet?",
      },
      whyGtm: {
        title: 'Why use GTM with JTracking',
        benefit1Title: 'Centralized tag management',
        benefit1Desc: 'Manage Meta, Google Ads, TikTok and other tracking tags in one place.',
        benefit2Title: 'Full visibility & control',
        benefit2Desc: 'All tags are deployed in your GTM workspace and can be reviewed anytime.',
        benefit3Title: 'Reliable tracking infrastructure',
        benefit3Desc: 'GTM provides a flexible foundation for both browser and server-side tracking.',
        needAccount: "Don't have a GTM setup yet?",
      },
      noAccountCard: {
        title: 'No GTM account',
        desc: "Connect your Google account and we'll guide you through creating one.",
        link: 'Connect Google Account →',
      },
      newContainer: {
        title: 'Create a dedicated container',
        desc: 'JTracking can create a container automatically during setup. If you already have containers, we recommend creating a new one to keep your existing setup unchanged.',
        link: 'Create Container →',
      },
      connectReady: 'Connect GTM with Google',
    },
    gtm: {
      intro: {
        question: 'What are we setting up here?',
        answer: `By connecting your GTM account, JTracking automatically pushes all tracking events into your Web container and routes them through your Server container for server-side processing — giving you more accurate attribution, the ability to bypass ad blockers, and better data ownership. Select or create your containers and workspace below to get started.`,
        needHelp: 'Need help?',
        link1: 'Create GTM account & containers',
        link2: 'Create Server GTM & get config',
      },
      refresh: 'Refresh',
      refreshing: 'Refreshing...',
      accountEmpty: {
        title: 'No GTM accounts found.',
        desc: 'You need a Google Tag Manager account before selecting a container.',
        goToGTM: 'Go to Google Tag Manager',
        howTo: 'How to create a GTM account',
      },
      containerEmpty: {
        title: 'No GTM containers found.',
        desc: 'Create a new container to get started.',
      },
      createBtn: 'Create',
      createContainerBtn: '+ Create Container',
      createWorkspaceTooltip: 'Create workspace',
      containerBanner: 'Container "{name}" created · {gtmId}',
      containerBannerTip: 'Install the loader code in the Pre-deploy Setup step.',
      containerMissingTip: 'The previously connected container could not be found. Please re-select.',
      webContainerHint: 'Used for your Shopify storefront (web browser)',
      serverContainerHint: 'Used for server-side event processing',
      switchedAccount: 'Switched to {email}',
      loadingContainers: 'Loading containers...',
      webCardSubtitle: 'Tracks events in the browser',
      serverCardSubtitle: 'Receives events on your server for better accuracy',
      containerMissingBanner: 'The previously connected container could not be found. Please re-select below.',
      accountMissingBanner:
        'The previously connected GTM account was not found in your current Google account. Please re-authorize or select a different account.',
      saveTip: 'Connection saved. Next:',
      saveTipLink: 'Go to Server-side Setup →',
      workspaceEmpty: {
        title: 'No workspaces found.',
        desc: 'Create a default workspace to continue.',
        createBtn: 'Create Default Workspace',
        creating: 'Creating...',
      },
      createContainer: {
        title: 'Create Container',
        webSubtitle: 'Web GTM',
        serverSubtitle: 'Server GTM',
        warning:
          "Action required after creation: A new container requires a GTM loader code to be installed on your website. You'll be guided through this in the Pre-deploy Setup step.",
        targetPlatform: 'Target Platform',
        nameLabel: 'Container Name',
        namePlaceholder: 'e.g. My Store - JTracking',
        submitBtn: 'Create Container',
        creating: 'Creating...',
        successMsg: 'Container "{name}" created successfully.',
        errorDuplicate: 'A container with this name already exists. Please choose a different name.',
        errorPermission:
          "You don't have permission to create a container. Please re-authorize with the correct Google account.",
        errorQuota:
          'Your GTM account has reached the container limit. Please manage your containers in Google Tag Manager.',
        errorGeneral: 'Failed to create container. Please try again.',
      },
      createWorkspace: {
        title: 'Create Workspace',
        nameLabel: 'Workspace Name',
        namePlaceholder: 'e.g. Default Workspace',
        submitBtn: 'Create Workspace',
        creating: 'Creating...',
        successMsg: 'Workspace "{name}" created successfully.',
        errorGeneral: 'Failed to create workspace. Please try again.',
      },
    },
    shopify: {
      desc: 'Complete GTM connection first to enable Shopify verification.',
      descNoServer: 'Create a server first to enable Shopify verification.',
      title: 'Shopify Setup',
      gtmid: 'GTM ID',
      someWrong: 'Shopify Setup Verification Failed',
      shopifyTip: 'Shopify detected. Complete the setup in your admin to enable tracking. Need help? Follow our guide.',
      shopifyTipKey: 'Follow our guide',
      guide: {
        title: 'Shopify Setup Guide',
        stepByStep: 'Step-by-Step Instructions',
        part1: `## 1. Insert script in \`theme.liquid\`
        
### 1.1. Open theme.liquid  

Sign in to your Shopify, go to **Online Store → Themes → More → Edit code**. `,
        part2: `In the left sidebar, open **layout/theme.liquid** under the Layout directory.`,
        part3: `### 1.2. Code  

Paste the following script above the closing \`</head>\` tag in your **layout/theme.liquid** file.`,
        part4a: `Finally, click **SAVE** from the top right corner.`,
        part4b: `## 2. Add Custom pixel

### 2.1. Add Customer Events

Sign in to your Shopify, go to **Settings → Customer events → More views → Custom pixels.**`,
        sappPart1: `## 1. Enable JTracking GTM Head

1.1 In Shopify Admin, go to **Online Store > Themes**.

1.2 On your current theme, click **Edit theme**.`,
        sappPart2: `1.3 In the theme editor, open **App embeds** (plug icon).

1.4 Find **JTracking GTM Head** and turn it on.

1.5 Click **Save**.`,

        part5: `Click **Add custom pixel.**`,
        part6: `Set Pixel name as **JTracking** and **Add pixel**.`,
        part7: `### 2.2. Customer Privacy

Do the following settings:  

- **Permission**: Not required  

**Data sale**: Data collected does not qualify as data sale`,
        part8: `### 2.3. Code  

Copy-paste the following script to the **Code** field.`,
        part9: `Finally, click **Save.**`,
        part10: `And then **Connect** from the upper right corner.`,
        part11: `## 3. Verification

3.1. Click **Verify**

3.2. If Shopify is set up correctly, the status will show as **'Verified'**. You can then click **'Continue to GTM Preview'** to continue.`,
      },
      verifyTip: 'Verifying Shopify setup. This may take up to 20 seconds',
      verifySuccess: 'Pre-deploy setup verified',
      verifyFailed: 'Shopify verification failed. Please follow the setup guide to complete the configuration.',
      replaceText: 'setup guide',
      verified: 'Verified',
      verifying: 'Verifying',
      unverified: 'Unverified',
    },
  },
  genericSetup: {
    title: 'Custom Loader Setup',
    nextButtonDisabledTip: 'Please verify your installation before proceeding',
    whyTitle: 'Why do you need a Custom Loader?',
    whyPoints:
      '1. **Beat Ad Blockers (Anti-AdBlock):** Disguises GTM scripts as first-party requests, bypassing browser extension blocks to recover 10%–30% of lost tracking data.\n\n2. **Extend Data Lifespan:** Circumvents Safari/Firefox tracking restrictions (ITP/ETP), extending cookie lifetime from 24 hours to 7+ days for more accurate attribution.',
    ctaNote:
      'Follow the steps above to replace or add the front-end snippets. Once deployed, click **Verify** to confirm the installation.',
    emptyDescPre: 'Complete',
    emptyDescLink: 'GTM connection',
    emptyDescPost: 'first to enable verification.',
    emptyGtmTitle: 'GTM connection required',
    emptyGtmBtn: 'Go to GTM Connector',
    emptyNoServerDescPre: 'Create a',
    emptyNoServerDescLink: 'server',
    emptyNoServerDescPost: 'first to enable verification.',
    emptyServerTitle: 'Server setup required',
    emptyServerBtn: 'Go to Server-side Setup',
    step1:
      "If you have an existing GTM snippet installed, please find and **remove** the script containing **{gtmId}** from your website's source code first.",
    step2: '**Copy and paste** Code Snippet 1 into the `<head>` section of every page.',
    step3: '**Copy and paste** Code Snippet 2 after the opening `<body>` tag on every page.',
    step4Pre: 'Deploy your website changes and click the',
    step4Post: 'button to confirm the loader is active.',
    verifyBtn: 'Verify Installation',
    verifyFailedTitle: 'Pre-deploy Setup Verification Failed',
    verifiedTitle: 'Installation Verified',
    verifiedDesc: "Your GTM loader is active and ready. You're set to deploy with first-party tracking.",
  },
  stepConfirm: {
    title: 'Confirm Changes',
    desc: 'You’ve updated this step. These changes may affect the configuration of the following steps. You’ll need to review them again before deploying.',
    confirm: 'Confirm & Continue',
  },
  // init
  initSite: {
    title: 'Initializing your site',
    desc: 'Preparing ad tracking best practices for your site.',
    progress: {
      desc: 'Applying ad tracking best practices to your site...',
    },
    footer: 'Please stay on this page. The Quick Start guide will appear once setup is ready.',
    finish: {
      title: 'Site initialization completed',
      desc: 'We’ve identified your site as {type} and optimized the setup path for you.',
      noType: 'We couldn’t identify a specific platform. We’ll guide you through the AI-assisted setup to continue.',
    },
  },
  // 灯泡引导
  guide: {
    builder: {
      title: 'Event Builder',
      desc: `This module helps you select the key events you want to track, based on industry best practices.  

These events define your conversion goals and tracking signals for analytics and ad platforms.  

During deployment, JTracking will automatically generate the required GTM configuration based on your selection.`,
    },
    primaryCommerce: {
      title: 'Primary E-commerce Events',
      desc: `These are the core e-commerce tracking events, commonly used as conversion goals.  

Selecting these events ensures that you capture the most important user actions that directly impact your business metrics.  

These events form the foundation for all subsequent tracking and reporting.`,
    },
    supplementaryCommerce: {
      title: 'Supplementary E-commerce Events',
      desc: `These are additional e-commerce events we provide to enhance your tracking and conversion measurement.  

They capture extra user interactions that can help you better understand user behavior and optimize campaigns.  

Selecting them is optional but recommended if you want a more complete view.`,
    },
    connect: {
      title: 'GTM Connector',
      desc: `In this module, you can connect your Google Tag Manager account and select the container and workspace you want to use.  

JTracking will deploy the generated tracking configuration to the selected workspace during deployment.  

JTracking does not affect your live site until you publish the changes in GTM. You stay in full control and can review, test, and submit the changes in GTM.`,
    },
    connectSetup: {
      title: 'What happens here?',
      desc: `Authorize your Google account to get started. We'll detect your existing GTM setup automatically — or guide you through creating one if needed.`,
      connectedTitle: 'How to configure',
      connectedDesc: `Select the Web and Server GTM containers where your tracking tags will be deployed. If your account is expired or switched, use Re-authorize to refresh access.`,
    },
    server: {
      title: 'Server-side Setup',
      desc: `Server-side Setup provides a managed server where your Server-side GTM container runs.  

By running tracking through a server endpoint, you can improve data reliability and support server-side tracking.  

You can also optionally configure a first-party domain to send data from your own domain.`,
    },
    containerConfig: {
      desc: `Identifies the Server-side GTM container used to process and forward events.`,
      link: 'Where to find',
    },
    sgtm: {
      title: `sGTM Usage`,
      desc: `This section shows your request limit per subscription period and the number of requests used so far.  

Monitoring this helps you avoid exceeding your quota.  

You can upgrade your plan at any time to increase your request limit and maintain uninterrupted tracking.`,
    },
    domain: {
      title: `Domains`,
      desc: `This is the server domain used for server-side tracking.

You can configure a first-party domain to send data from your own domain, which improves data accuracy and reduces potential ad-blocker or browser restrictions.

For example, if your website's main domain is \`www.demo.com\`, you can set the tracking domain to \`track.demo.com\`.

This setting is optional and can be updated later if needed.`,
    },
    platform: {
      title: `Platform Integration`,
      desc: `This module helps you configure the platforms where your tracking data will be sent.  

GA4 is required as the primary analytics destination.  

You can also connect ad platforms like Meta and Google Ads to receive conversion data after deployment.`,
    },
    deployment: {
      title: `Deployment`,
      desc: `In this module, you can review your tracking setup and submit the deployment.

JTracking will generate and deploy the tracking configuration to your connected GTM workspace.

After deployment, you can preview and submit the changes directly in GTM.`,
    },
    verifyLaunch: {
      title: 'Verify & Launch',
      desc: `This step verifies your GTM snippet installation and previews live tracking signals before publishing your container.

It ensures your setup is complete and working correctly so your changes go live with confidence.`,
    },
  },
  verifyLaunch: {
    title: 'Verify & Launch',
    back: 'Back',
    continueTo: {
      gtmPreview: 'Continue to GTM Preview',
      publishContainer: 'Continue to Workspace Status',
      finishSetup: 'Finish Setup →',
    },
    steps: {
      gtmIntegration: {
        label: 'GTM Integration',
        subPending: 'Install & verify snippet',
        subDone: 'Loader verified ✓',
      },
      gtmPreview: {
        label: 'GTM Preview',
        subPending: 'Tracking verification',
        subDone: 'Signal detected ✓',
      },
      publishContainer: {
        label: 'Workspace Status',
        subPending: 'Go live',
        subDone: 'Published ✓',
      },
    },
    step1: {
      banner: {
        detecting: 'Verifying GTM integration on your site…',
        detectingSub: 'Looking for {gtmId}',
        passStatus: 'GTM ID — {gtmId} is active on your site.',
        passCustomLoader: 'Custom Loader — gtm.js loading from your JTracking server domain.',
        passContainerConfirmed: 'Container ID confirmed',
        failStatus: "GTM snippet not detected. Let's get it installed.",
        failSub: 'No matching GTM ID found on your site',
      },
      scenario: {
        whoSetup: "Who's setting this up?",
        notDev: "I'm not a developer",
        notDevSub: "I'll send instructions to my team",
        canEdit: "I can edit my website's code",
        canEditSub: 'Show me the snippets',
        currentSetup: "What's your current setup?",
        noGtm: 'No GTM on my site yet',
        keepGtm: 'I need to keep another GTM running',
      },
      whyTip: {
        title: 'Why is this snippet different from standard GTM?',
        messagePre: 'This loads from your own server domain instead of',
        messagePost:
          '. That makes it a first-party request, so ad blockers let it through and cookies last 7+ days instead of 24 hours.',
      },
      tutorial: {
        addSnippet1Head: 'Add Snippet 1 to your',
        snippet1HeadLabel: 'Snippet 1 — paste above </head>',
        addSnippet2Body: 'Add Snippet 2 after',
        snippet2BodyLabel: 'Snippet 2 — paste after <body>',
        snippet1CoexistLabel: 'Snippet 1 — add alongside existing GTM',
        deployVerify: 'Deploy and verify',
        deployVerifyPre: 'Deploy your website, then',
        deployVerifyChangesPre: 'Deploy your website changes, then',
        deployVerifyPost: 'the setup.',
        verifyBtn: 'Verify',
        fresh: {
          step1Desc:
            "Open your website's HTML template and find the closing </head> tag. Paste Snippet 1 just above it on every page.",
          step2Desc: 'Find the opening <body> tag and paste Snippet 2 just after it.',
        },
        coexist: {
          tip: "You have another GTM container on your site. Keep it — do not remove it. You're adding JTracking's loader as an additional script alongside your existing one.",
          step1Desc: "Paste Snippet 1 alongside your existing GTM snippet (before or after — order doesn't matter).",
          step2Desc: 'Paste Snippet 2 immediately after the opening <body> tag.',
        },
        replace: {
          tipTitle: 'Replacing your current GTM loader',
          tipMessage:
            "You're replacing the standard GTM loader with JTracking's Custom Loader. This makes your tracking load as a first-party request — bypassing ad blockers and extending cookie lifetimes.",
          step1Title: 'Remove your existing GTM snippet',
          step1Desc:
            'Find and {remove} the script tag containing your current GTM ID. Also remove the matching {noscript} block below your opening {body} tag.',
          step1Remove: 'remove',
          step1Noscript: '<noscript><iframe>',
          step2Desc: 'Paste our snippet in the same location where your old GTM snippet was.',
          step3Desc: 'Paste Snippet 2 immediately after the opening <body> tag.',
        },
      },
      sendDev: {
        title: 'Not a developer? Send to your team.',
        copyMsg: 'Copy message',
        copied: 'Copied!',
        desc: 'Copy the message below and send it to whoever manages your website. The snippets are pre-filled.',
      },
      customLoader: {
        guideTitle: 'Custom Loader installation guide',
      },
      upgradeCard: {
        title: 'Boost Your Tracking with Custom Loader',
        optional: 'Optional',
        sub: 'Your GTM is active. Optionally upgrade to Custom Loader for better data quality.',
        benefit1Title: 'Beat ad blockers',
        benefit1Desc: '— Recover 10–30% of lost tracking data',
        benefit2Title: 'Longer cookie lifetimes',
        benefit2Desc: '— Extend from 24 hours to 7+ days (bypasses ITP/ETP)',
        setupBtn: 'Set Up Custom Loader',
      },
    },
    step2: {
      guide: {
        title: 'Steps to complete GTM Preview',
        step1: 'Click {openGtm} below — GTM Tag Assistant opens in a new tab. Enter your site URL and click {connect}.',
        step2: 'Your site opens with a GTM Preview panel at the bottom. {dontClose}.',
        step2DontClose: "Don't close that tab",
        step3: 'Trigger an event — visit a product page, add to cart, or complete a checkout.',
        step4: 'Come back here — signals will appear in the table below automatically.',
        viewGuide: 'View GTM Preview guide →',
      },
      gate: {
        title: 'Confirm Your Tracking is Working',
        desc: "We'll open GTM Preview Mode in a new tab and listen for server-side signals in real time. Follow the steps to trigger test events on your site.",
        openBtn: 'Open GTM Preview',
        workspaceWarn:
          'The selected workspace no longer exists. Please go back to {connect} and re-select a workspace.',
        hint: 'GTM Preview opens in a new tab · This page starts listening automatically',
      },
      toolbar: {
        live: 'Live',
        paused: 'Paused',
        timeout: 'Timeout',
        reconnect: 'Reconnect',
        signalCount: '{count} signals captured',
        openBtn: 'Open GTM Preview',
        workspaceNoExist: 'Workspace no longer exists — please reconnect',
        restartTip: 'Restart GTM Preview in a new tab',
      },
      table: {
        timestamp: 'Timestamp',
        event: 'Event',
        value: 'Value',
        page: 'Page',
        operator: 'Operator',
        details: 'Details',
        empty: 'Waiting for server-side events…',
        emptyHint: 'Trigger an action on your site, then check here',
        timeoutTitle: "Still waiting? Here's what to try:",
        timeoutStep1: 'Make sure you clicked {connect} in GTM Preview and your site loaded correctly.',
        timeoutStep2: 'Trigger an event — visit a product page, add to cart, or complete a checkout.',
        timeoutStep3: "If tags aren't firing in GTM Preview, confirm your GTM container has been published.",
      },
      props: {
        title: 'Event properties',
        basic: 'Basic',
        session: 'Session',
        system: 'System',
        utm: 'UTM',
        other: 'Other',
        showRawJson: 'Show Raw JSON',
        hideRawJson: 'Hide Raw JSON',
      },
    },
    step3: {
      card: {
        webConnection: 'Web GTM Connection',
        serverConnection: 'Server GTM Connection',
        container: 'Container',
        workspace: 'Workspace',
        workspaceChanges: 'Workspace Changes',
        modified: 'Modified',
        added: 'Added',
        deleted: 'Deleted',
        liveVersion: 'Live Version',
        changesNotPublished: 'Now Editing',
        noChanges: 'No Changes',
        versionLabel: 'Version {id}',
      },
      versionCard: {
        webLabel: 'Web Container',
        serverLabel: 'Server Container',
        version: 'Version',
        name: 'Name',
        description: 'Description',
        tags: 'Tags',
        triggers: 'Triggers',
        variables: 'Variables',
        openWeb: 'Open Web Container in GTM',
        openServer: 'Open Server Container in GTM',
      },
      publishContainerTitle: 'Workspace Status',
      completeBanner: {
        title: 'Tracking is Already Live',
        desc: 'Your GTM containers are already published. Your tracking is active and data is flowing to the dashboard.',
      },
      desc: "You're one step away from going live. Publishing will push your current JTracking configuration to both your Web and Server GTM containers. The updated tracking configuration will take effect immediately for all visitors on your site.",
      descWarn: '⚠ Publishing overwrites the current live version. You can roll back from the GTM console at any time.',
      publishing: 'Publishing…',
      submitBtn: 'Submit & Publish',
      failTitle: 'Failed to publish',
      publishFailed: 'Publish failed. Please try again.',
      retry: 'Retry',
      success: {
        title: 'Tracking is Live!',
        sub: 'Your GTM container has been published to production. Initial metrics will appear in your dashboard in 1–5 minutes.',
      },
      post: {
        title: 'Published Successfully',
        webVer: 'Web v{id}',
        srvVer: 'Server v{id}',
        guidance: "Your tracking data is now flowing. Here's what you can do in your Dashboard:",
        serverStatus: 'Server status & usage',
        serverStatusDesc: '- check your sGTM request volume and upgrade your plan under Overview',
        dataConnections: 'Data connections',
        dataConnectionsDesc: '- see which platforms (GA4, Meta, TikTok…) are connected in the Data Flow Topology',
        eventReception: 'Event reception',
        eventReceptionDesc: '- monitor real-time event counts and latest received timestamps under Data Reception',
        goToDashboard: 'Go to Dashboard →',
      },
      modal: {
        title: 'Publish Containers',
        tip: 'This will publish the JTracking tag configuration to both your Web and Server GTM containers simultaneously.',
        webContainer: 'Web Container',
        serverContainer: 'Server Container',
        versionName: 'Version Name',
        optional: '(optional)',
        descField: 'Description',
        namePlaceholder: 'e.g. Add purchase event tracking',
        descPlaceholder: 'What changed in this version?',
        cancel: 'Cancel',
        publish: 'Publish',
      },
    },
    guard: {
      deploy: {
        title: 'Deployment required',
        desc: 'Please complete the deployment step before proceeding to Verify & Launch.',
        action: 'Go to Deployment',
      },
      connector: {
        title: 'GTM not connected',
        desc: 'Connect your GTM workspace before proceeding to Verify & Launch.',
        action: 'Go to Connect',
      },
      server: {
        title: 'Server not configured',
        desc: 'Set up your server-side configuration before proceeding to Verify & Launch.',
        action: 'Go to Server',
      },
      workspace: {
        title: 'Workspace Not Found',
        desc: 'The selected workspace has been published or deleted. Please navigate to the GTM Connector to reselect and republish a workspace. If already published, you may monitor data reception status in the Dashboard.',
        actionPrimary: 'Go to GTM Connector',
        actionSecondary: 'Go to Dashboard',
      },
    },
  },
  // global
  jtracking: 'JTracking',
  pageNotFound: 'Page Not Found',
  enterPlaceHolder: 'Please Enter {target}',
  selectPlaceHolder: 'Please Select {target}',
  send: 'Send',
  loading: 'Loading...',
  confirm: 'Confirm',
  cancel: 'Cancel',
  scrollBottom: 'Scroll to the bottom',
  event: 'Event',
  parameter: 'Parameter',
  copy: 'Copy',
  copySucess: 'Copy Success',
  apply: 'Apply',
  applied: 'Applied',
  viewDetails: 'View details',
  more: 'More',
  retry: 'Retry',
  edit: 'Edit',
  save: 'Save',
  search: 'Search',
  website: 'Website',
  rename: 'Rename',
  verify: 'Verify',
  refresh: 'Refresh',
  us: 'America',
  recommended: 'Recommended',
  view: 'View',
  item: 'Item',
  notConfigured: 'Not Configured',
  configured: 'Configured',
  next: 'Next',
  delete: 'Delete',
  done: 'Done',
  name: 'Name',
  warning: 'Warning',
  ga4: 'GA 4',
  gads: 'Google Ads',
  meta: 'Facebook',
  account: 'Account',
  container: 'Container',
  workspace: 'Workspace',
  previous: 'Previous',
  running: 'Running',
  succeed: 'Succeed',
  failed: 'Failed',
  url: 'URL',
  create: 'Create',
  error: 'Error',
  notSiteFound: 'No site found',
  other: 'Other',
  continue: 'Continue',
  jumpTip: 'Go to {route}',
  number: 'Number',
  deploy: 'Deploy',
  required: 'Required',
  total: 'Total',
  viewDetail: 'View Details',
  subscribe: 'Subscribe',
  remove: 'Remove',
  connected: 'Connected',
  unconfirmed: 'Unconfirmed',
  confirmed: 'Confirmed',
  selected: 'selected',
  readmore: 'Read more',
  learnmore: 'Learn more',
  all: 'All',
  timezone: {
    placeholder: 'Select a timezone',
  },
};
